import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const SaveIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M17.22 4.12012H4.12V19.8801H19.88V6.78009L17.22 4.12012H17.22ZM8.98822 5.96009H14.2815V8.34748H8.98822V5.96009ZM18.04 18.0401H5.96002V5.96008H7.54822V9.78747H15.7216L15.82 5.96008L18.04 8.18011V18.0401V18.0401ZM12.0176 10.9597C10.4406 10.9597 9.15759 12.2427 9.15759 13.8197C9.15759 15.3967 10.4406 16.6797 12.0176 16.6797C13.5945 16.6797 14.8776 15.3967 14.8776 13.8197C14.8776 12.2427 13.5946 10.9597 12.0176 10.9597ZM12.0176 15.2397C11.2333 15.2397 10.5976 14.604 10.5976 13.8197C10.5976 13.0355 11.2333 12.3997 12.0176 12.3997C12.8018 12.3997 13.4376 13.0355 13.4376 13.8197C13.4376 14.604 12.8018 15.2397 12.0176 15.2397Z" />
    </SvgIcon>
  );
});
